import React from "react";
import styles from "./Hero.module.css";
import videoBG from "./video.mp4";
import { Swiper, SwiperSlide } from "swiper/react";
import Header from "../Header/Header";
import { Autoplay } from "swiper/modules";
import { useNavigate } from "react-router-dom";

const partnerImages = [
  "/images/icons/partner-logo-1.png",
  "/images/icons/partner-logo-2.png",
  "/images/icons/partner-logo-3.png",
  "/images/icons/partner-logo-4.png",
  "/images/icons/partner-logo-5.png",
]

const Hero = () => {
  const navigate = useNavigate()
  return (
    <div style={{position:"relative"}}>
        <div style={{position:"relative",zIndex:"10"}}>

        <Header/> 
        </div>
        <video
          className={styles.video}
          src={videoBG}
          autoPlay={true}
          loop={true}
          muted={true}
          playsInline={true}
        />
      <div className={styles.Hero}>
        {/* <div className={styles.overlay}></div> */}
        <div className="container my-auto ">

          <div className={[styles.Hero_Content]} >
            <h1 className={`hero-section-heading  text-center`} >
                Profit-Driven Accounting for Ambitious Businesses
              </h1>
            <p className="body-paragraph text-center mx-auto px-lg-5 mx-lg-5" >
            At Lotus Accounting, we go beyond tax filing. We help small and medium-sized businesses improve profitability, avoid late filings and overpaying taxes, and get expert financial guidance to grow with precision and confidence.
            </p>
            {/* <button className="hero-btn blue-btn" onClick={()=>{window.open("tel:+14169042013")}}>Get Consultation</button> */}
            <button className="hero-btn blue-btn" onClick={()=>{window.open("https://calendly.com/chandrancpa","blank")}}>Get Consultation</button>
          </div>
        </div>
        <div className={styles.logosCont}>
          <Swiper
            loop={true}
            autoplay={{
              delay: 1800,
              disableOnInteraction: false,
            }}
            modules={[Autoplay]}
            breakpoints={{
              1200: {
                slidesPerView: 4,
                spaceBetween: 30,
              },
              992: {
                slidesPerView: 3,
                spaceBetween: 25,
              },
              778: {
                slidesPerView: 3,
                spaceBetween: 20,
              },
              480: {
                slidesPerView: 2,
                spaceBetween: 20,
              },
              320: {
                slidesPerView: 1,
                spaceBetween: 20,
              },
            }}
          >
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-1.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-2.png"} alt="partner company logo" style={{maxWidth:"120px"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    {/* <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-3.png"} alt="partner company logo" style={{maxWidth:"200px"}} /> */}
                    <img loading="lazy" className="img-fluid " src={"/images/icons/cpao-logo.svg"} alt="partner company logo" style={{maxWidth:"160px"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-4.png"} alt="partner company logo" style={{maxWidth:"160px"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-5.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-6.png"} alt="partner company logo" style={{width:"140px"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-7.png"} alt="partner company logo" style={{height:"100%"}} />
                  </SwiperSlide>
                  <SwiperSlide className={styles.swiperSlide}>
                    <img loading="lazy" className="img-fluid " src={"/images/icons/partner-logo-8.png"} alt="partner company logo" style={{width:"180px"}} />
                  </SwiperSlide>
           
          </Swiper>
        </div>
      </div>
    </div>
  );
};

export default Hero;
